import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Description } from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-upsell-extras-modal',
  templateUrl: './upsell-extras-modal.component.html',
  styleUrls: ['./upsell-extras-modal.component.scss'],
})
export class UpsellExtrasModalComponent {
  /**
   * Emits boolean Clicked event
   */
  @Output() clicked: EventEmitter<{
    scrollToExtras: boolean;
    upsellPopupAction: string;
  }> = new EventEmitter();

  /**
   * Boolean value to set installationAvailable state
   */
  @Input() installationUpsellAvailable: boolean;

  /**
   * Boolean value to set disposalAvailable state
   */
  @Input() disposalUpsellAvailable: boolean;

  /**
   * Boolean value to determine single or multiple extras
   */
  isSingular: boolean;

  /**
   * Emits boolean value to parent that option was clicked
   * UpsellItems is used for GA to send the dynamic CTA content
   */
  onClick(value: boolean) {
    const upsellPopupAction = this.upsellItems
      ? value
        ? `Add ${this.upsellItems?.toLowerCase()}`
        : `Continue without ${this.upsellItems?.toLowerCase()}`
      : undefined;

    this.clicked.emit({ scrollToExtras: value, upsellPopupAction });
  }

  /**
   * Handle the content show depending on installationAvailable & disposalAvailable states
   */
  get upsellItems() {
    this.isSingular = true;
    if (this.installationUpsellAvailable && this.disposalUpsellAvailable) {
      this.isSingular = false;
      return `${
        Description.Installation
      } and ${Description.Recycling.toLowerCase()}`;
    } else if (this.installationUpsellAvailable) {
      return Description.Installation;
    } else if (this.disposalUpsellAvailable) {
      return Description.Recycling;
    }
  }
}
